<template>
  <div class="news">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>话题</p>
    </div>
    <el-form>
      <el-form-item label='話題名稱:'>
        <input maxlength="20" class="el-input__inner" type="text" v-model="name">
      </el-form-item>

      <el-form-item label="排序:">
        
        <input maxlength="2"  class="el-input__inner" type="text" v-model="sort" @change="sort=sort.replace(/^(0+)|[^\d]+/g,'')">
        
      </el-form-item>

      <el-form-item label="背景颜色:">
        
        <input maxlength="7" class="el-input__inner" type="text" v-model="backColor">
        
      </el-form-item>

      <el-form-item label="狀態">
        <el-select v-model="subjectStaust" placeholder="请选择">
          <el-option label="热门" value="1"></el-option>
          <el-option label="普通" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="上傳主圖:" class="picupload">
          <el-upload
            action=''
            :http-request='uploadRequest'
            :headers="{'Authorization': this.$cookie.get('auth')}"
            :with-credentials= "true"
            :on-remove="picHandleRemove"
            :on-error ='$errorImage'
            :file-list="picList"
            :on-exceed="$handleExceed.bind(this, 1)"
            :on-change="handleChange"
            :before-upload="beforePicUpload"
            :on-progress="uploadImgProcess"
            :limit= 1
            accept=".jpg,.jpeg,.png"
            :multiple='false'
            name= 'multipartFile'
            list-type="picture-card">
            <el-button v-if="!imgUploadFlag" size="small" type="primary">選擇圖片</el-button>
            <div slot="tip" class="el-upload__tip">需上傳完整750*400的正方形圖標，支持jpg/png格式(3MB以內)</div>
            <el-progress v-if="imgUploadFlag" type="circle" :percentage="imgUploadPercent" style="margin-top:10px;"></el-progress>
          </el-upload>
      </el-form-item>

      <el-form-item label='描述:'>
        <input maxlength="10" class="el-input__inner" type="text" v-model="description">
      </el-form-item>

      <el-form-item label="簡介:">
          <el-input
            maxlength='50'
            show-word-limit
            type="textarea"
            :autosize="{ minRows: 2}"
            placeholder="請輸入話題簡介"
            v-model="brief">
        </el-input>
      </el-form-item>

    </el-form>

    <div class="bottomBtn">
      <div class="btn" @click="reset()">重置</div>
      <div class="btn" @click="submitContent()">保存</div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from '@/components/dialog';
export default {
  props: ['type','id',],
  data () {
    return {
      name: '',
      sort: '',
      brief: '',
      description: '',
      dialogVisible: false,
      subjectStaust: '0',
      picList:[],
      imgUploadFlag: false, // 主图上传进度条显示flag
      imgUploadPercent: '', // 主图上传进度条
      backColor: '',
    }
  },
  created(){
    let _this = this;
    if (_this.type==='edit') {
    _this.getSubjectDetails();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取编辑話題详情
    getSubjectDetails(){
      let _this = this;
      _this.$get(`/request/community/getTopicbyId/${_this.id}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.picList.push({name: 'img.jpg', url: res.data.backImg});
            document.getElementsByClassName('el-upload')[0].style.display = 'none';
            _this.name = res.data.label;
            _this.sort = res.data.rank;
            _this.description = res.data.description;
            _this.brief = res.data.intro;
            _this.backColor = res.data.backColor;

            _this.subjectStaust = res.data.state.toString();
          } else {
            _this.$propMessage(res.message, 'error');
          }
        });
    },
    testColor(color) {
      var re1 = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i
      var re2 = /^rgb\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\)$/i
      var re3 = /^rgba\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,(1|1.0|0.[0-9])\)$/i
      return re2.test(color) || re1.test(color) || re3.test(color);
    },
    //重置內容
    reset(){
        let _this = this;
        _this.name = '';
        _this.sort = '';
        _this.brief = '';
        _this.picList = [];
        _this.description = '';
        _this.imgUploadFlag =  false;
        document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
        
    },
    picHandleRemove (file, fileList) {
      let _this = this;
      _this.imgUploadFlag = false;
      _this.$deleteUidItem(file.uid, _this.picList);
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';

    },
    // 图片列表发生改变的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    // 上传图片之前的回调函数
    beforePicUpload (file) {
      let _this = this;
      const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') ;
      const isLt2M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片只能是jpg或者png格式','error',function(){
          _this.dialogVisible = false;
        });
        return false
      };
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片大小不能超過3MB','error',function(){
          _this.dialogVisible = false;
        });
        return false};

      const isSize = new Promise(function (resolve, reject) {
        let width = 750
        let height = 400
        let _URL = window.URL || window.webkitURL
        let img = new Image()
        img.onload = function () {
          let valid = img.width === width && img.height === height;
          valid ? resolve() : reject(new Error())
        }
        img.src = _URL.createObjectURL(file)
      }).then(() => {
        return file
      }, () => {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片大小需為750*400！','error',function(){
          _this.dialogVisible = false;
        });
        return Promise.reject(new Error())
      })
      return isJPG && isLt2M && isSize;
    },
    // 图片上传进度条
    uploadImgProcess(event, file, fileList){
      console.log(event)
      this.imgUploadFlag = true;
      this.imgUploadPercent = file.percentage.toFixed(0);
    },
    uploadRequest(option){

      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        const fileWay = 'resource/image/'
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // console.log(client)
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName, // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file,{
            progress: function(p) {
              console.log(p)
              if(p>0){
                self.imgUploadFlag = true
              } else if(p=1){
                self.imgUploadFlag = false
              }
              self.imgUploadPercent =  Math.floor(p * 100)
            },headers:{'Cache-Control':'public'}})
          .then((val) => {
            if (val.res.statusCode === 200) {
              self.picList.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl+ val.name + self.$GLOBAL.xwPic})
              document.getElementsByClassName('el-upload')[0].style.display = 'none';
              //cdn预热
              self.$cdnFun(self.picList[0].url).then(res=>{
                // console.log(res)
              })
              return val
            } else {
              self.picList = [];
              option.onError('上传失败')
            }
          }, err => {
            self.picList = [];
            option.onError('上传失败')
            reject(err)
          })
        })
      })
    },
    // 提交内容
    submitContent(){
      let _this = this;
      if (_this.name === '' || _this.name.match(/^\s+$/) || _this.$getCaption(_this.name)) {
        _this.dialogVisible = true;
        _this.$propMessage('話題名稱不能為空或者含有非法字符','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };

      if (_this.sort === '') {
        _this.dialogVisible = true;
        _this.$propMessage('排序不能為空','error',function(){
        _this.dialogVisible = false;
        });
        return false;
      }

      if(_this.backColor !== '' && !_this.testColor(_this.backColor)) {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入正確背景顏色色值','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }

      if(_this.picList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('主圖不能為空','error',function(){
        _this.dialogVisible = false;
        });
        return false;
      }
      
      

      let param = {
        label: _this.name,
        rank: _this.sort,
        backImg: _this.picList[0].url,
        description: _this.description,
        intro: _this.brief,
        backColor: _this.backColor,
        state: Number(_this.subjectStaust),
      };

      // 新增话题提交
      if (_this.type === 'add') {
         
        _this.$post('/request/community/setTopic', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;

            if (res.code === '00000') {
              console.log('444')
              _this.$propMessage('新增話題發佈成功','success',
                function(){
                  _this.dialogVisible = false;
                  _this.$router.push('/subjectList');
                })

            }
            else{
              _this.$propMessage(res.message, 'error',
               function(){
                _this.dialogVisible = false;
               })
            }
          })
      } else if (_this.type === 'edit') {
        param.id = _this.id;
        // 编辑话题提交
        _this.$post('/request/community/updateTopic', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;

            if (res.code === '00000') {
              _this.$propMessage(
                '編輯話題發佈成功',
                'success',
                function(){
                  _this.dialogVisible = false;
                  _this.$router.push('/subjectList')
                })
            } 
            else{
              _this.$propMessage(res.message, 'error',
               function(){
                _this.dialogVisible = false;
               })
            };
          });
      };
    },
  },
  components: {
    DiaMess
  },
};
</script>
<style scoped lang="less">
  .ql-toolbar.ql-snow + .ql-container.ql-snow{
    background:#9e9e9e;
  }
</style>



// WEBPACK FOOTER //
// src/components/subject.vue